import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {withRouter, locationShape} from 'react-router';

import {Form, FormHandler} from 'spa/Components/Form';
import {withI18n} from 'spa/Components/Context';

import AddPaymentMethod from 'spa/Components/AddPaymentMethod/AddPaymentMethod';


import '../../Components/CheckoutPaymentDetails/checkout-payment-details.less';

@withRouter
@observer
@withI18n
class GiftsPaymentsection extends React.Component {
  static propTypes = {
    location: locationShape.isRequired,
    onApplePayClick: PropTypes.func.isRequired,
    onReceivePaymentForm: PropTypes.func.isRequired,
    orderContent: PropTypes.object.isRequired,
    paymentInfo: PropTypes.shape({
      paymentOption: PropTypes.string,
      paymentToken: PropTypes.string,
    }).isRequired,
    processingForm: PropTypes.bool,
    showPayNowButton: PropTypes.bool,
    showHeaderDetails: PropTypes.bool,
  };

  static defaultProps = {
    processingForm: false,
    showPayNowButton: true,
    showHeaderDetails: true,
  };

  render() {
    const {
      location,
      onApplePayClick,
      onReceivePaymentForm,
      processingForm,
    } = this.props;
    return (
      <React.Fragment>
        <FormHandler
          method="POST"
          onReceiveForm={onReceivePaymentForm}>
          <Form
            name="checkout"
            id="checkout"
            to={{
              pathname: location.pathname,
              query: location.query,
            }}
            method="POST"
            disabled={processingForm}
            className="dark v-container form gifts-checkout__checkout-form"
          >
            <React.Fragment>
              <AddPaymentMethod
                trackingCategory="Gifts"
                disabled={processingForm}
                processingForm={processingForm}
                onApplePay={onApplePayClick}
              />
            </React.Fragment>
          </Form>
        </FormHandler>
      </React.Fragment>
    );
  }
}

export default GiftsPaymentsection;



// WEBPACK FOOTER //
// ./spa/Pages/Gifts/GiftsPaymentSection.jsx